<mat-form-field class="example-chip-list">
  @if (label) {
    <mat-label>{{label}}</mat-label>
  }
  <mat-chip-grid #chipList
    [disabled]="formArray.disabled">
    @for (control of formArray.controls; track control; let index = $index) {
      <mat-chip-row
        [disabled]="formArray.disabled"
        [removable]="formArray.enabled"
        (removed)="removeChip(index)">
        {{control.value.displayName}}
        @if (formArray.enabled) {
          <mat-icon
            matChipRemove>
            cancel
          </mat-icon>
        }
      </mat-chip-row>
    }
    <input #input
      #autoTrigger="matAutocompleteTrigger"
      (click)="onClickTrigger()"
      [placeholder]="placeholder"
      [formControl]="formControl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete"
    (optionSelected)="optionSelected($event)">
    @for (option of filteredOptions; track option.id) {
      <mat-option
        [value]="option">
        {{option.displayName}}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
